module.exports = __webpack_public_path__ + "static/img/mapLine.65963474.png";